import Map from "./Map";

export default function App() {
  return (
    <div>
      <Map />
    </div>
  )
}
